import React from 'react'
import "./styles/section.css"

function Footer() {
  return (
    <div className='footer-cont'>
        <h3>Eat Healthy, Stay Healthy</h3>
    </div>
  )
}

export default Footer